export const QUALITY_SETTINGS = Object.freeze({
  low: { pixelRatio: 1, shadows: false, maxLights: 2, label: 'LOW' },
  medium: { pixelRatio: 1.25, shadows: true, maxLights: 3, label: 'MEDIUM' },
  high: { pixelRatio: 1.6, shadows: true, maxLights: 4, label: 'HIGH' },
  ultra: { pixelRatio: 2, shadows: true, maxLights: 4, label: 'ULTRA' }
});

export class QualityManager extends EventTarget {
  constructor(initial = 'medium') {
    super();
    this.level = QUALITY_SETTINGS[initial] ? initial : 'medium';
  }

  set(level, renderer) {
    if (!QUALITY_SETTINGS[level]) return;
    this.level = level;
    const settings = QUALITY_SETTINGS[level];
    if (renderer) {
      renderer.setPixelRatio(Math.min(devicePixelRatio || 1, settings.pixelRatio));
      renderer.shadowMap.enabled = settings.shadows;
    }
    this.dispatchEvent(new Event('change'));
  }

  get settings() { return QUALITY_SETTINGS[this.level]; }
}
